/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { IAaiVisitor } from '../visitors/IAaiVisitor';
import { Node } from '../../core/models/Node';
import { INamed } from '../../core/models/common/INamed';
import { Server } from '../../core/models/common/Server';
import { IVisitor } from '../../core/visitors/IVisitor';

/**
 * Constructor.
 * @param {Node} parent
 * @param {string} name
 * @class
 * @extends Server
 * @author eric.wittmann@gmail.com
 */
export abstract class AaiServer extends Server implements INamed {
    public _name : string;

    public protocol : string;

    public protocolVersion : string;

    public security : Array<AaiSecurityRequirement>;

    public bindings : AaiServerBindings;

    public constructor(parent? : any, name? : any) {
        if(((parent != null && parent instanceof <any>Node) || parent === null) && ((typeof name === 'string') || name === null)) {
            let __args = arguments;
            {
                let __args = arguments;
                super();
                if(this._name===undefined) this._name = null;
                if(this.protocol===undefined) this.protocol = null;
                if(this.protocolVersion===undefined) this.protocolVersion = null;
                if(this.security===undefined) this.security = null;
                if(this.bindings===undefined) this.bindings = null;
                if(this._name===undefined) this._name = null;
                if(this.protocol===undefined) this.protocol = null;
                if(this.protocolVersion===undefined) this.protocolVersion = null;
                if(this.security===undefined) this.security = null;
                if(this.bindings===undefined) this.bindings = null;
                (() => {
                    if(parent != null) {
                        this._parent = parent;
                        this._ownerDocument = parent.ownerDocument();
                    }
                })();
            }
            (() => {
                this._name = name;
            })();
        } else if(((typeof parent === 'string') || parent === null) && name === undefined) {
            let __args = arguments;
            let name : any = __args[0];
            super();
            if(this._name===undefined) this._name = null;
            if(this.protocol===undefined) this.protocol = null;
            if(this.protocolVersion===undefined) this.protocolVersion = null;
            if(this.security===undefined) this.security = null;
            if(this.bindings===undefined) this.bindings = null;
            if(this._name===undefined) this._name = null;
            if(this.protocol===undefined) this.protocol = null;
            if(this.protocolVersion===undefined) this.protocolVersion = null;
            if(this.security===undefined) this.security = null;
            if(this.bindings===undefined) this.bindings = null;
            (() => {
                this._name = name;
            })();
        } else if(((parent != null && parent instanceof <any>Node) || parent === null) && name === undefined) {
            let __args = arguments;
            super();
            if(this._name===undefined) this._name = null;
            if(this.protocol===undefined) this.protocol = null;
            if(this.protocolVersion===undefined) this.protocolVersion = null;
            if(this.security===undefined) this.security = null;
            if(this.bindings===undefined) this.bindings = null;
            if(this._name===undefined) this._name = null;
            if(this.protocol===undefined) this.protocol = null;
            if(this.protocolVersion===undefined) this.protocolVersion = null;
            if(this.security===undefined) this.security = null;
            if(this.bindings===undefined) this.bindings = null;
            (() => {
                if(parent != null) {
                    this._parent = parent;
                    this._ownerDocument = parent.ownerDocument();
                }
            })();
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.core.models.Node#accept(IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        let viz : IAaiVisitor = <IAaiVisitor><any>visitor;
        viz.visitServer(this);
    }

    /**
     * Creates a security requirement child node.
     * @return {AaiSecurityRequirement}
     */
    public abstract createSecurityRequirement() : AaiSecurityRequirement;

    /**
     * @see io.apicurio.datamodels.core.models.common.INamed#getName()
     * @return {string}
     */
    public getName() : string {
        return this._name;
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.INamed#rename(java.lang.String)
     * @param {string} newName
     */
    public rename(newName : string) {
        this._name = newName;
    }

    /**
     * Adds a security requirement child.
     * 
     * @param {AaiSecurityRequirement} securityRequirement
     * @return {AaiSecurityRequirement}
     */
    public addSecurityRequirement(securityRequirement : AaiSecurityRequirement) : AaiSecurityRequirement {
        if(this.security == null) {
            this.security = <any>([]);
        }
        /* add */(this.security.push(securityRequirement)>0);
        return securityRequirement;
    }
}
AaiServer["__class"] = "io.apicurio.datamodels.asyncapi.models.AaiServer";
AaiServer["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.common.INamed"];





import { AaiServerBindings } from './AaiServerBindings';


import { AaiSecurityRequirement } from './AaiSecurityRequirement';

